var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.5a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2v-8a2 2 0 012-2h14zm1 8H3v2a1 1 0 00.883.993L4 17.5h14a1 1 0 00.993-.883L19 16.5v-2zm-1-7H4a1 1 0 00-.993.883L3 8.5v5h16v-5a1 1 0 00-.883-.993L18 7.5zm-4.5-5a1.5 1.5 0 011.493 1.356L15 4v1.5a.5.5 0 01-.992.09L14 5.5V4a.5.5 0 00-.41-.492L13.5 3.5h-5a.5.5 0 00-.492.41L8 4v1.5a.5.5 0 01-.992.09L7 5.5V4a1.5 1.5 0 011.356-1.493L8.5 2.5h5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPage);
export default __webpack_public_path__ + "static/media/MyPage.8963cde8.svg";
export { ForwardRef as ReactComponent };